module.exports = {
      id: "68aad132e6d5025b358837b4f9875389state-bad.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#68aad132e6d5025b358837b4f9875389state-bad.svg",
      toString: function () {
        return this.url;
      }
    }